import { faCheck } from '@fortawesome/pro-light-svg-icons';

import { Button } from '@/components/ui/button/button.component';
import { maskPhone } from '@/utils/formatters/phonenumber';
import { SearchPartnerData } from '@/app/(main)/(pages)/busca/[slug]/_types/search-partner-data.type';

interface StandaloneAttentionContentProps {
  schedule: SearchPartnerData;
  onChangeContentToStandalone: (value: boolean) => void;
}

export function StandaloneAttentionContent({ schedule, onChangeContentToStandalone }: StandaloneAttentionContentProps) {
  const phone
    = schedule.partner.facility.contacts.phones.length > 0 ? maskPhone(schedule.partner.facility.contacts.phones[0]) : '';

  return (
    <div className="space-y-4">
      <p className="text-gray-700">
        A data e o horário do agendamento devem estar previamente confirmados com o estabelecimento pelo número:
        {' '}
        <br />
        {' '}
        <strong>
          <span>{phone}</span>
        </strong>
      </p>

      <Button startIcon={faCheck}>Li e concordo</Button>
      <Button variant="secondary" onClick={() => onChangeContentToStandalone(false)}>
        Cancelar
      </Button>
    </div>
  );
}
